var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.56474 15.3141L17.2036 6.67523L15.8444 5.26998L8.56474 12.5727L5.15529 9.14017L3.79611 10.4993L8.56474 15.3141ZM10.4998 0.916016C12.2506 0.916016 13.8709 1.35371 15.3606 2.22912C16.8043 3.05845 17.9407 4.19492 18.7701 5.63857C19.6455 7.1283 20.0832 8.74854 20.0832 10.4993C20.0832 12.2502 19.6455 13.8704 18.7701 15.3601C17.9407 16.8038 16.8043 17.9403 15.3606 18.7696C13.8709 19.645 12.2506 20.0827 10.4998 20.0827C8.74903 20.0827 7.12878 19.645 5.63906 18.7696C4.19541 17.9249 3.05894 16.7807 2.2296 15.3371C1.3542 13.8474 0.916504 12.2348 0.916504 10.4993C0.916504 8.7639 1.3542 7.15133 2.2296 5.66161C3.07429 4.21796 4.21845 3.07381 5.6621 2.22912C7.15182 1.35371 8.76439 0.916016 10.4998 0.916016Z",
    fill: "#34C768"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.7455fbba5117db30811f120f28cc6049.svg";
export { ForwardRef as ReactComponent };